import { StoreInterface } from '@Src/app/types';
import { useDispatch, useSelector } from 'react-redux';
import { setRgs, setGame } from '@Modal/reducers/general/generalSlice';

export const useGeneral = () => {
  const dispatch = useDispatch();
  const { rgs, game } = useSelector((state: StoreInterface) => state?.general);

  const handleRgsChange = (rgs: 'EU' | 'AS' | 'AS1' | 'SA') => {
    dispatch(setRgs(rgs));
  };

  const handleGameChange = (game: number) => {
    dispatch(setGame(game));
  };

  return {
    // State
    rgs,
    game,
    // Actions
    setRgs,
    setGame,
    // Handlers
    handleRgsChange,
    handleGameChange,
  };
};
